import { render } from "./SwdSubHeader.vue?vue&type=template&id=b408aa1a"
import script from "./SwdSubHeader.vue?vue&type=script&lang=js"
export * from "./SwdSubHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__